import { FaInstagram, FaGithub, FaLinkedin } from "react-icons/fa";
import styles from "./Footer.module.css"
const Footer = () => {
  return (
    <div className={styles.footer}>
      <ul>
        <li>
          <a href="https://www.instagram.com/_aviladev/">
            <FaInstagram size={30} />
          </a>
        </li>
        <li>
          <a href="https://github.com/EmersonAvilaDev">
            <FaGithub size={30} />
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/emerson-%C3%A1vila-42a931237/">
            <FaLinkedin size={30} />
          </a>
        </li>
      </ul>
      <p>avila_dev_emerson@proton.me</p>
      <p>Emerson Ávila © 2023</p>
    </div>
  );
};

export default Footer;
